import QuestionCreation from "pages/QuestionPage/questionCreation/QuestionCreation/QuestionCreation";

export default QuestionCreation;
